import styled from "styled-components"
import { Button, colors } from "@giphy/react-giphy-brand"
import ReactCodeInput from "react-code-input"
import { mobile } from "shared/util/media-query"

export const EmailValidationWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
`

export const HeaderGif = styled.img`
  width: 164px;
  height: 164px;
  margin-bottom: 6px;
  
  ${mobile.css`
    width: 100px;
    height: 100px
  `}
`

export const Message = styled.p`
  color: white;
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0px;
  line-height: 22px;
  margin-bottom: 40px;

  ${mobile.css`
    margin-top: 17px;
    margin-bottom: 25px;
  `}
`

export const Error = styled.p`
  color: ${colors.giphyRed};
  font-size: 15px;
  font-weight: normal;
  font-style: italic;
  text-align: center;
  letter-spacing: 0.11px;
`

export const Email = styled.span`
  color: ${colors.giphyBlue};
  font-weight: bold;
`

export const Footer = styled.p`
  color: white;
  font-size: 15px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0.11px;
  margin-bottom: 0px;
`

export const ResendLink = styled.button`
  color: white;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0.18px;
  line-height: 32px;
  padding: 0px 10px 10px;
  margin-bottom: 16px;
  background-color: transparent;
  border-width: 0;
`

export const StyledButton = styled(Button)`
  width: 100%;
  background: linear-gradient(-135deg, ${colors.giphyPurple}, ${colors.giphyIndigo});
`

export const StyledReactCodeInput = styled(ReactCodeInput)<{ error: any }>`
  margin-bottom: 50px;
  
  input {
    width: 52px;
    height: 52px;
    margin: 8px;
    border-radius: 4px;
    background: ${colors.giphyDarkCharcoal};
    font-size: 48px;
    text-align: center;
    color: ${colors.giphyAqua};
    font-size: 25px;
    font-family: NexaBlack;
    text-align: center;
    letter-spacing: 0.38px;
    line-height: 35px;
    border-width: 0;
    outline-width: 0;
    box-sizing: border-box;
    
    ${({ error }) => {
    return error ? `
      border-width: 2px;
      border-style: solid;
      border-color: ${colors.giphyRed};
      color: ${colors.giphyRed};  
    ` : ``
}
}
    
    &:focus {
      border-width: 2px;
      border-style: solid;
      border-color: ${colors.giphyGreen};
    }
  }
`

export const LoaderContainer = styled.div`
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
`
